import { GlAlert, GlSprintf } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import SecretsCount from '../../../../../../ee/app/assets/javascripts/delete_modal/components/delete_modal_secrets_count.vue?vue3';
import { __, s__ } from '~/locale';
import { numberToMetricPrefix } from '~/lib/utils/number_utils';
import GroupsProjectsDeleteModal from '../../../groups_projects/components/delete_modal.vue?vue3';
import { RESOURCE_TYPES } from '~/groups_projects/constants';
import { InternalEvents } from '../../../tracking/index.js?vue3';
export default {
    name: 'DeleteModal',
    RESOURCE_TYPES,
    i18n: {
        isForkAlertTitle: __('You are about to delete this forked project containing:'),
        isNotForkAlertTitle: __('You are about to delete this project containing:'),
        isForkAlertBody: __('This process deletes the project repository and all related resources.'),
        isNotForkAlertBody: __('This project is %{strongStart}NOT%{strongEnd} a fork. This process deletes the project repository and all related resources.'),
        isNotForkMessage: __('This project is %{strongStart}NOT%{strongEnd} a fork, and has the following:'),
        secretsCountFetchError: s__('SecretsManager|Failed to fetch secrets count.')
    },
    components: {
        GroupsProjectsDeleteModal,
        GlAlert,
        GlSprintf,
        SecretsCount
    },
    mixins: [
        InternalEvents.mixin()
    ],
    inject: [
        'triggerDeleteLocation'
    ],
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        confirmPhrase: {
            type: String,
            required: true
        },
        nameWithNamespace: {
            type: String,
            required: true
        },
        isFork: {
            type: Boolean,
            required: true
        },
        confirmLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        issuesCount: {
            type: Number,
            required: false,
            default: null
        },
        mergeRequestsCount: {
            type: Number,
            required: false,
            default: null
        },
        forksCount: {
            type: Number,
            required: false,
            default: null
        },
        starsCount: {
            type: Number,
            required: false,
            default: null
        },
        markedForDeletion: {
            type: Boolean,
            required: true
        },
        permanentDeletionDate: {
            type: String,
            required: true
        }
    },
    emits: [
        'change',
        'primary'
    ],
    data () {
        return {
            showSecretsCountFetchError: false
        };
    },
    methods: {
        numberToMetricPrefix,
        handlePrimary () {
            this.trackEvent('trigger_delete_on_project', {
                label: this.triggerDeleteLocation,
                property: String(this.markedForDeletion),
                actor: 'user'
            });
            this.$emit('primary');
        }
    }
};
